import { useEffect } from 'react';
import { appInsights } from '../../../../utils/appInsight_analytics';
import { APP_MOBILE } from '../../../../utils/app_constants';

export default function useFAQAnalytics(location, rawFormat) {
  useEffect(() => {
    if (appInsights) {
      const currentPath = location.pathname + location.search;
      appInsights.trackPageView({
        name: `${APP_MOBILE.WATCH}-chatbot-faq`,
        uri: currentPath,
        properties: { format: rawFormat }
      });
    }
  }, [location, rawFormat]);
}
